import { v4 as uuidv4 } from "uuid";

export const LS_WEBCHAT_UUID = "pr_id";

export function getVisitorId() {
  if (typeof window === "undefined") {
    return uuidv4();
  }
  try {
    const stored = window.localStorage?.getItem(LS_WEBCHAT_UUID);
    if (stored) return stored;
    const generated = uuidv4();
    window.localStorage?.setItem(LS_WEBCHAT_UUID, generated);
    return generated;
  } catch {
    return uuidv4();
  }
}
